import { EventsBySportIdRequest } from "sb-resp-lib";

export class LoadedData {
    private sportIds: string[]
    private tags: EventsBySportIdRequest.EventTagsEnum[]
    private dates: number[]

    constructor() {
        this.sportIds = [];
        this.tags = [];
        this.dates = [];
    }

    private setSportIds(sportIds: string[]) {
        this.sportIds = [...this.sportIds, ...sportIds];
    }

    private setDates(date: Date) {
        this.dates.push(date.getDate());
    }

    private setTags(tag: EventsBySportIdRequest.EventTagsEnum) {
        this.tags.push(tag);
    }

    /**
     * Clear all loaded data
     */
    clearData() {
        this.sportIds = [];
        this.tags = [];
        this.dates = [];
    }

    /**
     * Check if current sport ids were already loaded
     * @param {string[]} sportIds current ids
     * @returns {boolean}
     */
    containsSportIds(sportIds: string[]): boolean {
        return sportIds.every(id => this.sportIds.indexOf(id) !== -1);
    }

    /**
     * Check if current date was already loaded
     * @param {number} date current date
     * @returns {boolean}
     */
    containsDate(date: number): boolean {
        return this.dates.indexOf(date) !== -1;
    }

    /**
     * Check if current date & sport ids were already loaded
     * @param {string[]} sportIds current ids
     * @param {number} date current date
     * @returns {boolean}
     */
    containsSportIdsAndDate(sportIds: string[], date: Date): boolean {
        return this.containsSportIds(sportIds) && this.containsDate(date.getDate());
    }

    /**
     * Check if current tag was already loaded
     * @param {EventsBySportIdRequest.EventTagsEnum} tag current tag
     * @returns {boolean}
     */
    containsTag(tag: EventsBySportIdRequest.EventTagsEnum): boolean {
        return this.tags.indexOf(tag) !== -1;
    }

    /**
     * If there is sport, which was not loaded until now add it
     * and return true, else - false
     * @param {string[]} sportIds- current sport ids
     * @returns {boolean}
     */
    updateSports(sportIds: string[]): boolean {
        if (!this.containsSportIds(sportIds)) {
            this.setSportIds(sportIds);
            return true;
        }
        return false;
    }

    /**
     * If there is date, which was not loaded until now add it
     * and return true, else - false
     * @param {Date} date- current date
     * @returns {boolean}
     */
    updateDates(date: Date): boolean {
        if (!this.containsDate(date.getDate())) {
            this.setDates(date);
            return true;
        }
        return false;
    }

    /**
     * If there is tag, which was not loaded until now add it
     * and return true, else - false
     * @param {EventsBySportIdRequest.EventTagsEnum} tag - current tag
     * @returns {boolean}
     */
    updateTags(tag: EventsBySportIdRequest.EventTagsEnum): boolean {
        if (!this.containsTag(tag)) {
            this.setTags(tag);
            return true;
        }
        return false;
    }

}